import { difference } from 'lodash/fp';

import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { CheckStatus, IdDisallowedCountryDetection } from 'dashboard/models/check';
import { COUNTRIES, CountryCode } from 'lib/constants/locales';

export const computeIdDisallowedCountryDetectionMetadata = (
  check: IdDisallowedCountryDetection,
): CheckMetadata => {
  const metadata = [];

  const { 'country-code': detectedCountryCode, 'enabled-country-codes': enabledCountryCodes } =
    check.metadata || {};

  metadata.push({
    label: 'Detected Country',
    value: detectedCountryCode ? COUNTRIES[detectedCountryCode as keyof typeof COUNTRIES] : '-',
  });

  const selectedCountryCode = check?.metadata?.['selected-country-code'];
  if (
    selectedCountryCode &&
    check.status === CheckStatus.Failed &&
    check.reasons &&
    check.reasons.length > 0 &&
    check.reasons[0] === 'selected_country_mismatch'
  ) {
    metadata.push({
      label: 'Selected Country',
      value: COUNTRIES[selectedCountryCode as keyof typeof COUNTRIES],
    });
  }

  const displayCountry =
    enabledCountryCodes && enabledCountryCodes.length >= 105
      ? (difference(Object.keys(COUNTRIES), enabledCountryCodes) as CountryCode[])
      : enabledCountryCodes;
  const displayName =
    enabledCountryCodes && displayCountry
      ? displayCountry.map((code: CountryCode) => COUNTRIES[code]).join(', ')
      : '-';

  if (enabledCountryCodes) {
    metadata.push({
      label: 'Allowable Countries',
      value:
        enabledCountryCodes.length === 208
          ? 'All countries'
          : enabledCountryCodes.length < 105
            ? displayName
            : 'All countries except ' + displayName,
    });
  }

  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};
